import { GetGrade_getGrades } from "../__generated__/gql-types/GetGrade";
import { GetCoursesListBackOffice_getCoursesListBackOffice_grade } from "../__generated__/gql-types/GetCoursesListBackOffice";

export function formatGrade(
  grade:
    | GetGrade_getGrades
    | GetCoursesListBackOffice_getCoursesListBackOffice_grade
    | null
    | undefined
) {
  return grade?.name || "Sin grado";
}
